// Role helper utilities
// Managers have the same permissions as admins except they cannot see total paid revenue

/**
 * Check if user is an admin
 * @param {Object} user - The user object from auth context
 * @returns {boolean}
 */
export const isAdmin = (user) => {
  return user?.user_metadata?.role === 'admin';
};

/**
 * Check if user is a manager
 * @param {Object} user - The user object from auth context
 * @returns {boolean}
 */
export const isManager = (user) => {
  return user?.user_metadata?.role === 'manager';
};

/**
 * Check if user is an admin or manager
 * Managers have the same permissions as admins except they cannot see total paid revenue
 * @param {Object} user - The user object from auth context
 * @returns {boolean}
 */
export const isAdminOrManager = (user) => {
  const role = user?.user_metadata?.role;
  return role === 'admin' || role === 'manager';
};

/**
 * Check if user is a tech (regular user)
 * @param {Object} user - The user object from auth context
 * @returns {boolean}
 */
export const isTech = (user) => {
  const role = user?.user_metadata?.role;
  return role === 'tech' || role === 'user';
};

/**
 * Get user role
 * @param {Object} user - The user object from auth context
 * @returns {string} - The user's role ('admin', 'manager', 'tech', or 'user' for legacy)
 */
export const getUserRole = (user) => {
  return user?.user_metadata?.role || 'tech';
};
